import { KYC_TYPES_STATUS, KYC_TYPES, KYC_TOOL_TIP_CONTENT } from '@utils/constants';

export const generateKycStatusAttributes = (status) => {
    switch (status) {
        case 'A':
            return {
                status: KYC_TYPES_STATUS.APPROVED,
                statusText: 'kyc:completed',
                statusIcon: '/public/html/images/common_img/icon-resolved.svg',
            };
        case 'R':
            return {
                status: KYC_TYPES_STATUS.REJECTED,
                statusText: 'kyc:rejected',
                statusIcon: '/public/html/images/common_img/icon-error.svg',
            };
        case 'P':
            return {
                status: KYC_TYPES_STATUS.PENDING,
                statusText: 'kyc:pending',
                statusIcon: '/public/html/images/common_img/icon-pending.svg',
            };
        default:
            return {
                status: KYC_TYPES_STATUS.DOCUMENTREQUESTED,
                statusText: 'kyc:pending',
                statusIcon: '/public/html/images/common_img/icon-pending.svg',
            };
    }
};

export function generateKycLevelAttributes(level) {
    switch (level) {
        case 'L0':
            return {
                text: 'kyc:bankbook',
                labelIcon: '/public/html/images/kyc/webcam.svg',
                tooltipIcon: `/public/html/images/kyc/${KYC_TYPES.BANK_BOOK}.svg`,
                tooltipText: KYC_TOOL_TIP_CONTENT.B,
                applicantLevel: 'L0',
            };
        case 'L1':
            return {
                text: 'kyc:verifiedPlus',
                labelIcon: '/public/html/images/kyc/profile.svg',
                tooltipIcon: `/public/html/images/kyc/${KYC_TYPES.ID_AND_PASSPORT}.svg`,
                tooltipText: KYC_TOOL_TIP_CONTENT.IPL,
                applicantLevel: 'L1',
            };
        case 'L2':
            return {
                text: 'kyc:verifiedPlus',
                labelIcon: '/public/html/images/kyc/webcam.svg',
                tooltipIcon: `/public/html/images/kyc/${KYC_TYPES.ID_PASSPORT_LIVENESS}.svg`,
                tooltipText: KYC_TOOL_TIP_CONTENT.IPL2,
                applicantLevel: 'L2',
            };
        default:
            return {
                text: 'kyc:default',
                labelIcon: '/public/html/images/kyc/default.svg',
                tooltipIcon: '/public/html/images/kyc/default_tooltip.svg',
                tooltipText: 'kyc:defaultTooltip',
            };
    }
}

export function getKYCStatusByAPI(kycData) {
    if (!kycData || !kycData?.applicantStatus || !kycData?.applicantLevel) {
        console.error('kycData, applicantStatus, or applicantLevel is undefined');
        return null;
    }

    const statusInfo = generateKycStatusAttributes(kycData?.applicantStatus);
    const levelAttributes = generateKycLevelAttributes(kycData?.applicantLevel);

    return {
        ...statusInfo,
        ...levelAttributes,
    };
}
